// apps/web-outreach router (H.2.4 — chat-only surface).
//
// Outer Layout supplies the @rmint/shell AppLayout (topbar + container
// padding) that the inner OutreachChat negative-margins push against.
// RequireAdmin gates the chat surface to admin users.

import { createBrowserRouter, Navigate } from 'react-router-dom';
import { RequireAdmin } from '@rmint/shell';

export const router = createBrowserRouter([
  {
    path: '/',
    lazy: async () => {
      const { Layout } = await import('./routes/Layout');
      return { Component: Layout };
    },
    children: [
      { index: true, element: <Navigate to="/outreach" replace /> },
      {
        path: 'outreach',
        lazy: async () => {
          const { OutreachChat } = await import('./routes/Chat');
          return { Component: () => (<RequireAdmin><OutreachChat /></RequireAdmin>) };
        },
      },
    ],
  },
]);
